import { ApprovalState } from '../../@theme/type/approvalState';
import { ExpiredActionType } from '../type/expired-action-type';
import { MessageType } from '../type/message-type';
import { SharedFileType } from '../type/shared-file.type';
import { TargetType } from '../type/target-type';
import { SearchTarget } from './search-target';
import { User } from './user';

export class Message {
	id: string;
	state: ApprovalState;
	type: MessageType;
	requestMessage: string;
	forwardMessage: string;

	/* 파일정보 */
	fileCount: number;

	sender: Sender;
	files: File[];
	targets: Target[];

	created: Date;
	modified: Date;
	modifiedBy: string;
	deleted: Date;

	private _userCount: number;
	private _groupCount: number;

	constructor(obj?: any) {
		const message = obj || {};

		Object.assign(this, message);

		this.sender = message.sender ? new Sender(message.sender) : null;
		this.files = message.files ? message.files.map(f => new File(f)) : [];
		this.targets = message.targets ? message.targets.map(t => new Target(t)) : [];

		this.created = message.created ? new Date(message.created) : null;
		this.modified = message.modified ? new Date(message.modified) : null;
		this.deleted = message.deleted ? new Date(message.deleted) : null;
	}

	public get displayUserName() {
		return `${this.sender?.userName} ${(this.sender?.jobTitle ? '(' + this.sender?.jobTitle + ')' : '')}`;
	}

	public get user() {
		return {id: this.sender?.userId};
	}

	public get userCount() {
		if (this._userCount == undefined)
			this._userCount = this.targets ? this.targets.filter(t => t.targetType.toString() == TargetType[TargetType.USER].toString()).length : 0;

		return this._userCount;
	}
	
	public get groupCount() {
		if (this._groupCount == undefined)
			this._groupCount = this.targets ? this.targets.filter(t => t.targetType.toString() == TargetType[TargetType.GROUP].toString()).length : 0;
	
		return this._groupCount;
	}
}

export class Sender {
	/* 발신자 */
	userId: string;
	userName: string;
	email: string;
	userAuthId: string;
	jobTitle: string;
	groupId: string;
	groupName: string;
	clientId: string;
	pcName: string;
	remoteIp: string;
	localIp: string;

	constructor(obj?: any) {
		const shared = obj || {};
		Object.assign(this, shared);
	}
}

export class File {
	id: string; // {@link SharedFile.id}
	storageId: String; // {@link FileStorage.id}
	type: SharedFileType;
	sha256: string;
	headerHash: string;
	contentHash: string;
	fileName: string;
	filePath: string;
	fileSize: number;
	created: Date;
	deleted: Date;
	fileId: string;
	instanceId: string;
	projectId: string;

	constructor(obj?: any) {
		const shared = obj || {};
		Object.assign(this, shared);
		this.created = shared.created ? new Date(shared.created) : null;
		this.deleted = shared.deleted ? new Date(shared.deleted) : null;
	}
}

export class Target {
	id: string; // {@link SharedFile.id}
	targetId: string; // {@link FileStorage.id}
	targetType: TargetType;
	targetInfo: SearchTarget;
	permission: Permission;
	usersOfTarget: number;
	readUsersOfTarget: number;

	constructor(obj?: any) {
		const target = obj || {};
		Object.assign(this, target);
		this.targetInfo = target.targetInfo ? new SearchTarget(target.targetInfo) : null;
		this.permission = target.permission ? new Permission(target.permission) : null;
	}

	public get displayName(): string {
		if (this.targetType.toString() == TargetType[TargetType.USER].toString()) {
			return this.targetInfo ? `${this.targetInfo.name}${this.targetInfo.attrs.hasOwnProperty('JOBTITLE') ? (' (' + this.targetInfo.attrs['JOBTITLE'] + ')') : ''}` : '';
		} else {
			return this.targetInfo ? `${this.targetInfo.name}'}` : '';
		}
	}

	public get displayNameWithType(): string {
		if (this.targetType.toString() == TargetType[TargetType.USER].toString()) {
			return this.targetInfo ? `[USER] ${this.targetInfo.name}${this.targetInfo.attrs.hasOwnProperty('JOBTITLE') ? (' (' + this.targetInfo.attrs['JOBTITLE'] + ')') : ''}` : '';
		} else {
			return this.targetInfo ? `[GROUP] ${this.targetInfo.name}'}` : '';
		}
	}

	public get groupName(): string {
		if (this.targetType.toString() == TargetType[TargetType.USER].toString()) {
			return this.targetInfo ? `${this.targetInfo.attrs.hasOwnProperty('GROUP_NAME') ? this.targetInfo.attrs['GROUP_NAME'] : ''}` : '';
		} else {
			return this.targetInfo ? `${this.targetInfo.name}'}` : '';
		}
	}
}

export class Permission {
	permissions: number;
	expiredTime: Date;
	expiredAction: ExpiredActionType;
	expireReadCount: number;
	
	/* 파일권한 */
	readable: boolean;
	writeable: boolean;
	printable: boolean;

	constructor(obj?: any) {
		const permission = obj || {};
		Object.assign(this, permission);
		this.expiredTime = permission.expiredTime ? new Date(permission.expiredTime) : null;
	}
}

export class ReadSharedDocument {
	messageId: string;
	userId: string;
	groupId: string;
	created: Date;
	user: User;

	constructor(obj?: any) {
		const read = obj || {};
		Object.assign(this, read);
		this.created = read.created ? new Date(read.created) : null;
		this.user = read.user ? new User(read.user) : null;
	}
}
